<template>
	<div>
		<div class="modal-content flex">
			<span>{{ $t("modal.close.hasChanges.confirm.msg") }}</span>
		</div>
		<div class="flex flex_between">
			<md-button class="md-block" @click.stop="cancel">
				{{ $t("common.button.cancel") }}
			</md-button>
			<md-button class="md-blank" @click.stop="dontSave">
				{{ $t("common.dontSave") }}
			</md-button>
			<md-button :class="noticeModalData.data.saveButtonClass ? noticeModalData.data.saveButtonClass : 'md-primary'" @click.stop="save">
				{{ noticeModalData.data.saveButtonText ? noticeModalData.data.saveButtonText : $t("common.save") }}
			</md-button>
		</div>
	</div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
	computed: {
		...mapGetters({
			noticeModalData: "noticeModalData",
		}),
	},
	methods: {
		closeNoticeModal() {
			this.$store.dispatch("setActionNoticModal", { show: false, data: {} });
		},
		cancel() {
			if (this.noticeModalData.data.onCancel) {
				this.noticeModalData.data.onCancel();
			}
			this.closeNoticeModal();
		},
		dontSave() {
			if (this.noticeModalData.data.onNotSave) {
				this.noticeModalData.data.onNotSave();
			}
			this.closeNoticeModal();
		},
		save() {
			if (this.noticeModalData.data.onSave) {
				this.noticeModalData.data.onSave();
			}
			this.closeNoticeModal();
		}
	},
};
</script>

<style lang="scss" scoped>
	.modal-body .modal-content {
		min-height: 75px;
	}
</style>
